import { toast } from "react-toastify";

import CarrierCapacityTable from "./tables/CarrierCapacityTable/CarrierCapacityTable";
import CarrierPlanCapacityTable from "./tables/CarrierPlanCapacityTable/CarrierPlanCapacityTable";
import CarrierPreferredLaneTable from "./tables/CarrierPreferredLaneTable/CarrierPreferredLaneTable";
import { useGetEquipmentOptions } from "hooks/useGetEquipmentOptions";
import { postCarrierCapacityNote } from "./api/carrierCapacityApi";
import { SelectedCarrier } from "models/SelectedCarrier";
import useReloadCarrierActivities from "pages/CarrierEdit/hooks/useReloadCarrierActivities";
import CarrierCapacityShipmentMatches from "./CarrierCapacityShipmentMatches";
import { useGetCarrierCapacities } from "./hooks/useGetCarrierCapacities";
import { useGetCarrierPlanCapacities } from "./hooks/useGetCarrierPlanCapacities";

import styles from "./CarrierCapacity.module.scss";

type CarrierCapacityProps = {
  carrier: SelectedCarrier;
};

const CarrierCapacity = (props: CarrierCapacityProps) => {
  const capacities = useGetCarrierCapacities({
    carrierId: props.carrier.id,
    filter: { types: ["Capacity", "NoCapacity"] },
  });
  const preferredLanes = useGetCarrierCapacities({
    carrierId: props.carrier.id,
    filter: { types: ["Preferred Lane"] },
  });
  const planCapacities = useGetCarrierPlanCapacities({
    carrierId: props.carrier.id,
  });

  const { data: equipmentOptions } = useGetEquipmentOptions();
  const reloadActivities = useReloadCarrierActivities();

  const updateCarrierTimeline = async (note: string) => {
    try {
      await postCarrierCapacityNote({
        carrierId: props.carrier.id,
        note,
      });

      toast.success("Carrier timeline updated");
    } catch (error) {
      console.error({ error });
      toast.error("Error updating carrier timeline");
    }
  };

  return (
    <div className={styles.carrierCapacity}>
      <CarrierCapacityShipmentMatches
        carrier={props.carrier}
        equipmentOptions={equipmentOptions}
        capacities={capacities}
        preferredLanes={preferredLanes}
      />
      <CarrierCapacityTable
        carrier={props.carrier}
        capacities={capacities}
        equipmentOptions={equipmentOptions}
        updateCarrierTimeline={updateCarrierTimeline}
        refreshCarrierTimeline={reloadActivities}
      />
      <CarrierPlanCapacityTable
        carrier={props.carrier}
        planCapacities={planCapacities}
        updateCarrierTimeline={updateCarrierTimeline}
        refreshCarrierTimeline={reloadActivities}
      />
      <CarrierPreferredLaneTable
        carrier={props.carrier}
        preferredLanes={preferredLanes}
        equipmentOptions={equipmentOptions}
        refreshCarrierTimeline={reloadActivities}
      />
    </div>
  );
};

export default CarrierCapacity;
